import { ImageType } from '../types/ImageTypes';
import { FaSeedling, FaDatabase, FaSearch, FaDownload, FaShoppingCart } from 'react-icons/fa';

interface HomeDesktopProps {
  mainImage: ImageType;
  googlePlayImg: string;
  playStoreUrl: string;
}

export function HomeDesktop({ mainImage, googlePlayImg, playStoreUrl }: HomeDesktopProps) {
  return (
    <div className="hidden md:flex flex-col items-center w-full">
      <h1 className="text-4xl font-bold mt-8 mb-12 px-4 text-center pt-16">
        <span className="text-season-green">Season:</span> Listes & Recettes
      </h1>
      <div className="w-full max-w-7xl mx-auto flex flex-col items-center gap-8 md:gap-16 px-4 md:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-6 lg:gap-8 xl:gap-16 w-full">
          <div className="flex-1 relative w-full min-w-0">
            <img
              src={mainImage.src}
              alt={mainImage.alt}
              className="w-full h-auto max-h-[50vh] md:max-h-[55vh] lg:max-h-[60vh] xl:max-h-[65vh] object-contain rounded-2xl shadow-lg"
            />
          </div>

          <div className="flex flex-col flex-1 gap-6 lg:gap-8 min-w-0">
            <h2 className="text-2xl font-bold text-left">
              <FaSeedling className="inline-block mr-2 text-season-green" />
              Au gré des saisons
            </h2>
            <div className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed flex flex-col gap-4 text-justify">
              <p>
                <strong className=" text-season-green">Season:</strong> L&R est
                une application intuitive pour gérer{" "}
                <strong>vos repas au quotidien</strong>. Créez ou <strong>importez
                facilement des recettes</strong> de saison depuis le web et ajoutez <strong>les ingrédients en un clic</strong> dans vos listes de courses.
              </p>
              <p>
                Grâce à <strong>un planificateur pratique</strong>, organisez vos repas pour
                toute la semaine en quelques étapes. <strong>Exportez ou importez vos
                données</strong> pour une gestion simple et sécurisée, idéale pour
                changer d'appareil ou créer des sauvegardes.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <a 
            href={playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={googlePlayImg}
              alt="Get it on Google Play"
              className="w-52 hover:opacity-90 transition-opacity"
            />
          </a>
        </div>
      </div>

      {/* Encart points principaux */}
      <div className="w-full mt-16 mb-16 px-6 py-16 bg-[#242323] border-y border-gray-700">
        <div className="w-full max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-start gap-4">
              <FaDatabase className="text-[#7CA834] text-2xl mt-1 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-white mb-2 text-lg">Base de données de produits de saison</h4>
                <p className="text-base text-gray-300">Accédez à une base de données de plus de 100 produits locaux avec leurs informations saisonnières</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <FaSearch className="text-[#7CA834] text-2xl mt-1 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-white mb-2 text-lg">Détection intelligente des produits</h4>
                <p className="text-base text-gray-300">Identification automatique des ingrédients de saison dans vos recettes</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <FaDownload className="text-[#7CA834] text-2xl mt-1 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-white mb-2 text-lg">Importation de recettes</h4>
                <p className="text-base text-gray-300">Importez facilement des recettes depuis le web, la détection automatique des ingrédients de saison se fera automatiquement</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <FaShoppingCart className="text-[#7CA834] text-2xl mt-1 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-white mb-2 text-lg">Création rapide de liste de courses</h4>
                <p className="text-base text-gray-300">Générez automatiquement vos listes de courses à partir de vos recettes en 1 clic</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 